export enum AuthResponseCodes {
  PASSCODE_NON_EXISTENT = 'PASSCODE_NON_EXISTENT',
  PASSWORD_ALREADY_USED = 'PASSWORD_ALREADY_USED',
  PASSWORD_INVALID = 'PASSWORD_INVALID',
  SESSION_NOT_FOUND = 'SESSION_NOT_FOUND',
  INVALID_MDN_ERROR = 'INVALID_MDN_ERROR',
  OTP_SEND_ERROR = 'OTP_SEND_ERROR',
  OPERATION_NOT_PERMITTED = 'OPERATION_NOT_PERMITTED',
}

export enum IdentifierType {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
}

export enum CredentialType {
  EMAIL_OTP = 'EMAIL_OTP',
  TEXT_OTP = 'TEXT_OTP',
  VOICE_OTP = 'VOICE_OTP',
  PASSWORD = 'PASSWORD',
  SOCIAL_GOOGLE = 'SOCIAL_GOOGLE',
  SOCIAL_APPLE = 'SOCIAL_APPLE',
  CARRIER_PIN = 'CARRIER_PIN',
  SOFT = 'SOFT',
}

export enum CarrierPinValidationType {
  PostalCode = 'PostalCode',
  LastName = 'LastName',
}

export type CarrierPinOptions = {
  isAllowed: boolean;
  encryptionRequired: boolean;
  validationType?: CarrierPinValidationType;
};

export type SendOTPResponse = {
  transactionId: string;
};

export type SubscriberIdentification = {
  clientChannelId: string;
  subscriberNumber: string;
};

export type ValidatedAgreements = {
  subscriber?: SubscriberIdentification;
};

export enum AdditionalValidationTypes {
  LastNamePostalCode = 'LastNamePostalCode',
}

export type AdditionalValidations = {
  additionalValidationsId: string;
  additionalValidationTypes: AdditionalValidationTypes[];
};

export type AgreementResponse = {
  validatedAgreements?: ValidatedAgreements[];
  additionalValidations?: AdditionalValidations;
};

export type VerificationResult = AgreementResponse & {
  valid: boolean;
  attemptsRemaining: number;
  lockedOut: boolean;
};

export type EncryptedCarrierPin = {
  keyId: string;
  phaseBit: string;
};

export type ClearTextCarrierPin = {
  keyId?: never;
  phaseBit?: never;
};

export type VerifyCarrierPinRequest = (
  | EncryptedCarrierPin
  | ClearTextCarrierPin
) & {
  pin: string;
  lastName?: string;
  postalCode?: string;
};

export type VerifyLastNamePostalCodeRequest = {
  lastName: string;
  postalCode: string;
};

export type VerifyAdditionalValidationRequest =
  VerifyLastNamePostalCodeRequest & {
    additionalValidationsId: string;
  };
